import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIcons42Component } from './simple-icons-42.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIcons42Component ],
    exports:      [ SimpleIcons42Component ],
    bootstrap:    []
})
export class SimpleIcons42Module {}
